"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getGlobalVirtualCategory = void 0;
const routes_1 = require("../../routes");
const getGlobalVirtualCategory = (client) => async (params) => {
    const url = routes_1.ENDPOINTS.GET_GLOBAL_VIRTUAL_CATEGORY.applyParams(params);
    const response = await client.get(url);
    return response.data;
};
exports.getGlobalVirtualCategory = getGlobalVirtualCategory;
